<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <div>
          <card>
            <v-spacer/>
            <v-dialog
              v-model="dialog"
              persistent
              max-width="768px">
              <template v-slot:activator="{ on }">
                <v-layout>
                  <v-flex
                    xs9
                    sm9
                    md9>
                    <base-input
                      v-model="search"
                      :loading="loading"
                      label="Search"
                      placeholder="Search..."
                      hide-details
                      @keyup.enter="index"/>
                  </v-flex>
                  <v-flex
                      xs3
                      sm3
                      md3>
                    <base-button
                        class="float-right"
                        @click="index">
                      更新
                    </base-button>
                  </v-flex>
                </v-layout>
              </template>
              <card :title="'编辑： ' + editedItem.title">
                <v-container grid-list-md >
                  <v-layout wrap>
                    <v-flex
                      xs12
                      sm12
                      md12>
                      <base-input
                        v-model="editedItem.id"
                        :disabled="true"
                        required
                        label="Id"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md12>
                      <base-input
                        v-model="editedItem.slug"
                        required
                        label="Slug" />
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md12>
                      <base-checkbox
                        :checked="editedItem.pin"
                        style="display: inline"
                        required
                        label="Pin"
                        @input="editPin" >
                        Pin
                      </base-checkbox>
                      for
                      <base-input
                        v-model="editedItem.days"
                        style="display: inline"
                        required
                        type="number"
                        label="Days"
                      />
                    </v-flex>
                    <!--                    </v-flex>-->
                    <!--                    <v-flex-->
                    <!--                        xs12-->
                    <!--                        sm12-->
                    <!--                        md12>-->
                    <!--                      <base-input-->
                    <!--                          required-->
                    <!--                          v-model="editedItem.link"-->
                    <!--                          label="Link" >-->
                    <!--                      </base-input>-->
                    <!--                    </v-flex>-->
                    <!--                    <v-flex-->
                    <!--                        xs12-->
                    <!--                        sm12-->
                    <!--                        md12>-->
                    <!--                      <base-checkbox-->
                    <!--                          v-model="editedItem.active"-->
                    <!--                      > Active </base-checkbox>-->
                    <!--                    </v-flex>-->
                  </v-layout>
                </v-container>

                <v-card-actions>
                  <base-button
                    @click="close">Cancel</base-button>

                  <v-spacer/>
                  <base-button
                    type="primary"
                    @click="save">Save</base-button>
                </v-card-actions>
              </card>

              <card :title="'转载/转移设置'">
                <v-container grid-list-md >
                  <v-layout wrap>
                    <v-flex
                      xs12
                      sm12
                      md12>
                      <div v-if="editedItem.link">
                        <label>
                          <a
                            v-if="editedItem.link.startsWith('http')"
                            :href="editedItem.link"
                            target="_blank"
                          >
                            转载原始链接 <i class="tim-icons icon-link-72"/>
                          </a>
                          <span v-else>
                            备注
                          </span>
                        </label>
                        <base-input v-model="editedItem.link" />

                      </div>
                      <base-input
                        v-else
                        v-model="editedItem.link"
                        label="转载原始链接(必须http或者https开头)或者备注"
                      />
                    </v-flex>
                    <base-button
                      v-if="editedItem.transfer"
                      type="primary"
                      @click="generateTransferLink">更新原始链接或备注
                    </base-button>
                    <v-flex
                      xs12
                      sm12
                      md12>
                      <div v-if="editedItem.transfer">
                        <label>
                          点击复制以下转移链接:
                        </label>
                        <p
                          class="pointer"
                          @click="copyUrl(transferUrl)">
                          {{ transferUrl }}
                        </p>
                      </div>
                    </v-flex>
                    <v-flex
                        xs12
                        sm12
                        md12>
                      <div v-if="editedItem.transfer">
                        <label>
                          点击复制以下删除链接:
                        </label>
                        <p
                            class="pointer"
                            @click="copyUrl(deleteUrl)">
                          {{ deleteUrl }}
                        </p>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-card-actions>
                  <base-button
                    @click="close">Cancel</base-button>
                  <v-spacer/>
                  <base-button
                    v-if="!editedItem.transfer"
                    type="primary"
                    @click="generateTransferLink">生成转移链接
                  </base-button>
                  <base-button
                    v-if="editedItem.transferred"
                    type="primary"
                    @click="restoreTransferLink">
                    已转移，点击重新开启转移链接
                  </base-button>
                </v-card-actions>
              </card>
            </v-dialog>
            <v-data-table
              :headers="headers"
              :items="TopicList"
              :pagination.sync="pagination"
              :total-items="totalTopics"
              :loading="loading"
              :light="false"
              class="table table-striped"
            >

              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <tr @click="editItem(props.item)">
                  <td>
                    {{ (props.item.category ? (props.item.category.name + ': ') : '') + props.item.category_id }}
                  </td>

                  <td>
                    {{ props.item.title }}
                  </td>
                  <td>{{ props.item.user.name }}</td>
                  <td>
                    {{ props.item.reply_count }}
                  </td>
                  <td>
                    {{ props.item.view_count }}
                  </td>
                  <td>
                    <v-icon v-if="props.item.published">check</v-icon>
                  </td>
                  <td>
                    {{ (props.item.display_order && props.item.display_order) > 0 ? '📌': '' }}
                  </td>
                  <td>
                    <v-icon v-if="props.item.transfer">check</v-icon>
                    <v-icon v-if="props.item.transfer&&props.item.transfer.deleted_at&&!props.item.deleted_at" style="color:green">done_all</v-icon>
                    <v-icon v-if="props.item.transfer&&props.item.transfer.deleted_at&&props.item.deleted_at"  style="color:red">delete</v-icon>
                  </td>
                  <td>
                    <v-icon v-if="props.item.deleted_at" style="color:red">delete</v-icon>
                  </td>
                  <td class="justify-center ">
                    <a
                      :href="webUrl + props.item.id + '/' + props.item.slug + '?admin=' + Math.random()"
                      target="_blank"
                      title="Edit topic">
                      &nbsp;
                      &nbsp;
                      <i class="tim-icons icon-link-72 pointer">
                        &nbsp;
                        &nbsp;
                      </i>
                    </a>
                  </td>

                </tr>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snack"
              :timeout="5000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close</v-btn>
            </v-snackbar>
          </card>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import BaseButton from '@/components/BaseButton'

export default {
  components: { BaseButton },
  data: () => ({
    snack: false,
    snackColor: '',
    snackText: '',
    pagination: {
      rowsPerPage: 10,
      sortBy: 'published',
      descending: 'true'
    },
    TopicList: [

    ],
    webUrl: '',
    totalTopics: 0,
    loading: true,

    startCalendar: false,
    endCalendar: false,

    checkboxAdmin: true,
    checkboxActive: true,
    rowsAmount: [10, 20, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
    dialog: false,

    search: '',
    headers: [
      {
        text: '板块',
        value: 'category_id'
      },
      {
        text: '名字',
        value: 'title'
      },
      {
        text: '作者',
        value: 'user_id'
      },
      {
        text: '回复数',
        value: 'reply_count'
      },
      {
        text: '点击数',
        value: 'view_count'
      },
      {
        text: '已发布?',
        value: 'published'
      },
      {
        text: '置顶?',
        value: 'display_order'
      },
      {
        text: '待转移',
        align: 'left',
        value: 'transfer',
        sortable: false
      },
      {
        text: '已删除',
        align: 'left',
        value: 'deleted_at',
        sortable: true
      },
      // {
      //   text: 'Active',
      //   value: 'active',
      // },
      {
        text: 'Edit Link',
        value: 'Edit Link',
        sortable: false
      }
    ],
    editedIndex: -1,
    editedItem: {
      id: '',
      title: '',
      pin: false,
      days: 1,
      slug: '',
      transfer: '',
      transferred: false,
      link: ''
    },
    defaultItem: {
      id: '',
      title: '',
      pin: false,
      days: 1,
      slug: '',
      transfer: '',
      transferred: false,
      link: ''
    }
  }),

  computed: {
    ...mapState('app', ['color']),
    transferUrl: function () {
      return this.webUrl + this.editedItem.id + '?transfer=' + this.editedItem.transfer
    },
    deleteUrl: function () {
      return this.webUrl + this.editedItem.id + '?delete=' + this.editedItem.transfer
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    pagination: {
      handler () {
        this.index()
      },
      deep: true
    }
  },
  created () {
    this.webUrl = location.protocol + '//' + this.$store.state.city.id + '.' + this.customerWebDomain + '/topics/'
  },

  methods: {
    copyUrl: function (link) {
      if (navigator.clipboard == null) {
        this.$message({
          message: '复制失败，请手动复制URL',
          type: 'error'
        })
      }
      navigator.clipboard.writeText(link).then(
        () => {
          this.$message({
            message: '复制成功',
            type: 'success'
          })
        },
        () => {
          this.$message({
            message: '复制失败，请手动复制URL',
            type: 'error'
          })
        }
      )
    },
    index () {
      this.$store.state.spinning = true
      this.loading = true
      const params = new URLSearchParams(this.pagination)

      params.append('search', this.search)
      let self = this
      axios.get('/topics?' + params.toString())
        .then(response => {
          self.TopicList = response.data.data
          self.totalTopics = response.data.total
          self.$store.state.spinning = false
          self.loading = false
        })
        .catch(err => {
          if (err.response.status == '403') {
            this.showError('Unauthorized')
          } else {
            this.showError(JSON.stringify(err.response.data.errors))
          }
          self.$store.state.spinning = false
          self.loading = false
          console.log(err.response.data.errors)
        })
    },

    // object.assign fills in the empty object with the properties of item
    editItem (item, dbox = true) {
      this.editedIndex = this.TopicList.indexOf(item)
      this.editedItem = {
        id: item.id,
        title: item.title,
        pin: item.display_order > 0,
        days: 1,
        slug: item.slug,
        transfer: item.transfer ? item.transfer.code : '',
        transferred: item.transfer ? item.transfer.deleted_at !== null : false,
        link: item.transfer ? item.transfer.link : ''
      }
      this.dialog = dbox
    },

    editPin (pin) {
      this.editedItem.pin = pin
    },
    callTableAction (item, endpoint, method) {
      let tableItem = this.editedItem
      this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
        .then((response) => this.saveInline())
        .catch(error => {
          console.log(error)
          this.cancelInline
        })
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      // update
      if (this.editedIndex !== -1) {
        this.$store.state.spinning = true
        axios.put('/topics/' + this.editedItem.id, this.editedItem)
          .then((response) => {
            // Object.assign(this.TopicList[this.editedIndex], response.data)
            this.index()
            this.saveInline()
            this.close()
            this.$store.state.spinning = false
          }
          )
          .catch(error => {
            if (error.response && error.response.status == '422') {
              this.showError(JSON.stringify(error.response.data.errors))
            } else {
              this.showError(error.response.data)
            }
            console.log(error)
            this.cancelInline
            this.$store.state.spinning = false
          })
      }
    }, // toasts/snackbar messages for actions
    generateTransferLink () {
      if (this.editedIndex !== -1) {
        this.$store.state.spinning = true
        axios.post('/topics/transfer', {
          'topic_id': this.editedItem.id,
          'link': this.editedItem.link
        })
          .then((response) => {
            Object.assign(this.TopicList[this.editedIndex], response.data)
            this.$store.state.spinning = false
            this.dialog = false

            this.editItem(this.TopicList[this.editedIndex])
            // this.editedIndex = this.editedIndex
            this.$message({
              message: '更新成功',
              type: 'success'
            })
          }
          )
          .catch(error => {
            if (error.response && error.response.status == '422') {
              this.showError(JSON.stringify(error.response.data.errors))
            } else {
              this.showError(error.response.data)
            }
            console.log(error)
            this.$store.state.spinning = false
          })
      }
    },
    restoreTransferLink () {
      if (this.editedIndex !== -1) {
        this.$store.state.spinning = true
        axios.put('/topics/transfer/restore', {
          'topic_id': this.editedItem.id
        })
          .then((response) => {
            Object.assign(this.TopicList[this.editedIndex], response.data)
            this.$store.state.spinning = false
            this.dialog = false
            this.editItem(response.data)
          }
          )
          .catch(error => {
            if (error.response && error.response.status == '422') {
              this.showError(JSON.stringify(error.response.data.errors))
            } else {
              this.showError(error.response.data)
            }
            console.log(error)
            this.$store.state.spinning = false
          })
      }
    },
    saveInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Topic saved'
    },
    deleteInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Topic deleted'
    },
    showError (errorMessage) {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = errorMessage || 'Something went wrong, try again later!'
    },
    cancelInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    reset () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data reset to default'
    },
    openInline () {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    closeInline () {
      console.log('Dialog closed')
    }
  }
}
</script>

<style>
table.v-table thead tr {
  color: red !important;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}
</style>
